import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import ShopPortal from "@/pages/ShopPortal";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/shops" element={<ShopPortal />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: {
                        background: "#ffffff",
                        color: "#1c1917",
                        border: "1px solid #e7e5e4",
                    },
                }}
            />
        </div>
    );
}

export default App;
